import { Page } from '@/core/architecture'

import { ConsoleFansTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleFans Page
 * 推し登録者一覧画面
 */
export const ConsoleFans: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleFansTemplate state={state} {...actions} />
}
